var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10ZM4.53125 6.71875V5.46875H3.28125C3.02148 5.46875 2.8125 5.25977 2.8125 5C2.8125 4.74023 3.02148 4.53125 3.28125 4.53125H4.53125V3.28125C4.53125 3.02148 4.74023 2.8125 5 2.8125C5.25977 2.8125 5.46875 3.02148 5.46875 3.28125V4.53125H6.71875C6.97852 4.53125 7.1875 4.74023 7.1875 5C7.1875 5.25977 6.97852 5.46875 6.71875 5.46875H5.46875V6.71875C5.46875 6.97852 5.25977 7.1875 5 7.1875C4.74023 7.1875 4.53125 6.97852 4.53125 6.71875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.57b0834179ba57e4410f0e0b5fb98e9e.svg";
export { ForwardRef as ReactComponent };